import { BulkSpreadsheet, parseBool, type BulkColumn } from '../shared/BulkSpreadsheet';
import { attendanceService } from '@kss/api';
import type { AttendanceCreate } from '@kss/api';
import { loadEmployeeOptions } from '../shared/formLoaders';

const columns: BulkColumn<AttendanceCreate>[] = [
  { key: 'employeeId', header: 'Employee', required: true, dataType: 'lookup', loadOptions: loadEmployeeOptions },
  { key: 'date', header: 'Date', required: true, dataType: 'date', sample: new Date().toISOString().slice(0, 10) },
  { key: 'checkInTime', header: 'Check-in', sample: '09:00' },
  { key: 'checkOutTime', header: 'Check-out', sample: '18:00' },
  { key: 'status', header: 'Status', sample: 'Present' },
  { key: 'notes', header: 'Notes' },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkAttendance() {
  return (
    <BulkSpreadsheet<AttendanceCreate> title="Bulk import attendance" entityLabel="attendance entry" backPath="/panel/attendance" columns={columns} module="Attendance"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, isActive: r.isActive ?? true }));
        const created = await attendanceService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
